<mat-progress-bar mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" fxLayoutAlign="space-between center">
  <mmx-breadcrumbs
    *ngIf="patient && intake && appointment"
    [breadcrumbs]="[patient, appointment, intake]"
  ></mmx-breadcrumbs>
  <div
    *ngIf="intake"
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="1rem"
  >
    <button
      mat-stroked-button
      *ngIf="
        appointment?.intakeStatus &&
        appointment.intakeStatus !== 'N' &&
        intake != null
      "
      [matMenuTriggerFor]="intakeDownloadMenu"
    >
      <mat-icon>print</mat-icon>
      <span>{{ 'common.print' | translate }}</span>
    </button>
  </div>
  <mat-menu #intakeDownloadMenu="matMenu">
    <button
      mat-menu-item
      (click)="download($event, 'combined')"
      matTooltip="Registration, Questionnaire, Consents, and Patient-Uploaded Photos"
    >
      {{ 'patient-intake.print-type.combined-with-photos' | translate }}
    </button>
    <button
      mat-menu-item
      (click)="download($event, 'combined-without-photos')"
      matTooltip="Registration, Questionnaire &amp; Consents"
    >
      {{ 'patient-intake.print-type.combined-without-photos' | translate }}
    </button>
    <button mat-menu-item (click)="download($event, 'intake')">
      {{ 'patient-intake.print-type.registration-questionnaire' | translate }}
    </button>
    <button mat-menu-item (click)="download($event, 'registration')">
      {{ 'patient-intake.print-type.registration' | translate }}
    </button>
    <button mat-menu-item (click)="download($event, 'questionnaire')">
      {{ 'patient-intake.print-type.questionnaire' | translate }}
    </button>
    <button
      mat-menu-item
      (click)="download($event, 'combined-consents')"
      *ngIf="intake?.consents && intake?.consents.length > 1"
    >
      {{ 'patient-intake.print-type.combined-consents' | translate }}
    </button>
    <button mat-menu-item (click)="download($event, 'insurance-card')">
      {{ 'patient-intake.print-type.insurance-cards' | translate }}
    </button>
    <button mat-menu-item (click)="download($event, 'identification')">
      {{ 'patient-intake.print-type.identification' | translate }}
    </button>
    <button
      mat-menu-item
      *ngFor="let documentType of documentTypes"
      (click)="download($event, 'custom.' + documentType)"
    >
      {{ documentType }}
    </button>
    <ng-container *ngIf="intake?.consents && intake?.consents.length > 0">
      <button
        mat-menu-item
        *ngFor="let consent of intake.consents"
        (click)="download($event, 'consent.' + consent.id)"
        [matTooltip]="consent.title"
      >
        {{ 'common.consent' | translate }}: {{ consent.title }}
      </button>
    </ng-container>
    <ng-container *ngIf="imageQuestions.length > 0">
      <button
        mat-menu-item
        *ngFor="let imageQuestion of imageQuestions"
        (click)="downloadImage(imageQuestion)"
      >
        {{ 'common.image' | translate }}:
        {{ getQuestionField(imageQuestion.id, 'label') }}
      </button>
    </ng-container>
  </mat-menu>
</div>
<div *ngIf="!isLoading && intake">
  <div fxLayout="row" fxLayout.lt-md="column">
    <mmx-consents fxFlex="50"></mmx-consents>
    <mmx-procedures-card
      *ngIf="appointment && products.length > 0"
      fxFlex="50"
      [appointment]="appointment"
      [products]="products"
      [clinic]="clinic"
    ></mmx-procedures-card>
  </div>
  <mmx-timeline
    *ngIf="intake.statusTransitions && appointment"
    [patient]="patient"
    [appointment]="appointment"
  ></mmx-timeline>
  <mat-card
    class="default"
    [class.card-has-subtitle]="
      (intake.isConfirmed && clinicianName) || unsignerName
    "
  >
    <mat-card-title>
      <span>{{ 'patient-intake.title' | translate }}</span>
    </mat-card-title>
    <mat-card-subtitle *ngIf="intake.isConfirmed && clinicianName">
      {{ 'patient-intake.signed-off-by' | translate: { clinicianName } }}
      {{ intake.confirmed?.date | momentDateTime: 'local' }}.
      <ng-container *ngIf="clinic.modules.tech; else intakeLocked">
        {{ 'patient-intake.intake-revise' | translate }}
      </ng-container>
      <ng-template #intakeLocked>
        {{ 'patient-intake.intake-locked' | translate }}
      </ng-template>
    </mat-card-subtitle>
    <mat-card-subtitle *ngIf="unsignerName">
      {{
        'patient-intake.unsigned-by'
          | translate: { clinicianName: unsignerName }
      }}
      {{ intake.unsigned?.date | momentDateTime: 'local' }}.
      {{ 'patient-intake.please-sign' | translate }}
    </mat-card-subtitle>
    <mat-card-content>
      <div *ngFor="let section of sections" class="section">
        <ng-container *ngIf="section.default; else customSections">
          <div class="section">
            <mmx-custom-section
              class="section"
              [section]="section"
              [customQuestions]="getLegQuestions(section.sectionId)"
            ></mmx-custom-section>
          </div>
        </ng-container>
        <ng-template #customSections>
          <div
            class="section"
            *ngIf="
              !section.isHidden && getLegQuestions(section.sectionId).length > 0
            "
          >
            <mmx-custom-section
              class="section"
              [section]="section"
              [customQuestions]="getLegQuestions(section.sectionId)"
            ></mmx-custom-section>
          </div>
        </ng-template>
      </div>
    </mat-card-content>
    <mat-card-actions
      *ngIf="intake && !intake.isSignedOff"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex></div>
      <mmx-progress-button
        (btnClick)="markConfirmed()"
        [options]="btnSignOff"
      ></mmx-progress-button>
    </mat-card-actions>
  </mat-card>
</div>
